import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=773e6b8a&scoped=true"
import script from "./activityPage.vue?vue&type=script&lang=js"
export * from "./activityPage.vue?vue&type=script&lang=js"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=773e6b8a&prod&scoped=true&lang=css"
import style1 from "./activityPage.vue?vue&type=style&index=1&id=773e6b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e6b8a",
  null
  
)

export default component.exports